/**
 * Centralized translations for Activities module
 * Contains all labels used across activities, board, and task editor components
 */

export const ActivitiesLabels = {
    it: {
        // Form placeholders
        name: 'Nome',
        nameTask: 'Nome del task',
        description: 'Descrizione',
        descriptionTask: 'Descrizione del task',
        
        // Date placeholders  
        whenTaskNeedToStart: 'Quando il task deve iniziare',
        whenTaskNeedToEnd: 'Quando il task deve finire',
        whenYouPlanToStartTask: 'Quando pianifichi di iniziare il task',
        whenYouPlanToEndTask: 'Quando pianifichi di finire il task',
        
        // Actions and buttons
        close: 'Chiudi',
        save: 'Salva',
        ok: 'OK',
        saveData: 'Salva i dati',
        
        // Modal titles and alerts
        error: 'ERRORE',
        success: 'Successo',
        info: 'INFO',
        deleted: 'ELIMINATO',
        oooops: 'OOOOOPS',
        
        // Messages
        savingData: 'Salvataggio dati',
        nameIsEmpty: 'Il nome è vuoto',
        thereAreSomeProblems: 'Ci sono alcuni problemi durante il salvataggio dei dati',
        taskDeletedCorrectly: 'Task {{taskName}} eliminato correttamente',
        areYouSure: 'Sei sicuro?',
        areYouSureDeleteTask: 'Sei sicuro di voler eliminare il task {{taskName}}?',
        
        // Navigation and general
        home: 'Home',
        newTask: 'Nuovo task',
        yes: 'SÌ',
        no: 'NO',
        
        // Boards specific
        yourBoards: 'Le tue board',
        preferredBoards: 'Board preferite',
        otherBoards: 'Altre board',
        hereYouCanFindYourPreferredBoards: 'Qui puoi trovare le tue board preferite',
        hereYouCanFindOtherBoards: 'Qui puoi trovare le altre board',
        addNewBoard: 'Aggiungi nuova board',
        openBoard: 'Apri board',
        edit: 'Modifica',
        delete: 'Elimina',
        boardDeletedCorrectly: 'Board {{boardName}} eliminata correttamente',
        areYouSureDeleteBoard: 'Sei sicuro di voler eliminare la board {{boardName}}?',
        dragToReorderLists: 'Trascina per riordinare le liste',
        
        // Task Editor specific
        taskLinkedToList: 'Questo task è collegato alla Lista Attività',
        fromTheBoard: 'dalla board',
        progress: 'Progresso',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        plannedStartDate: 'Data di inizio pianificata',
        plannedEndDate: 'Data di fine pianificata',
        executor: 'Esecutore',
        verifier: 'Verificatore',
        validator: 'Validatore',
        progressLimitError: 'Il progresso non può essere superiore al 100. Impostato automaticamente a 100',
        taskNameEmptyError: 'Il nome del task non può essere vuoto',
        taskUpdatedSuccess: 'Task aggiornato con successo',
        nothingToSave: 'Nulla da salvare',
        theBoard: 'La board',
        activityList: 'Lista attività',
        thisTask: 'Questo Task',
        
        // Activity List specific
        preferredLists: 'Liste Preferite',
        otherLists: 'Altre Liste',
        hereYouCanFindYourPreferredLists: 'Qui puoi trovare le tue liste preferite',
        hereYouCanFindTheOtherLists: 'Qui puoi trovare le altre liste',
        newActivityList: 'Nuova lista attività',
        newTask: 'Nuovo task',
        areYouSureDeleteList: 'Sei sicuro di voler eliminare la board {{boardName}}?',
        listDeletedCorrectly: 'Board {{boardName}} eliminata correttamente',
        movingListToOther: 'Spostamento {{listName}} nelle altre liste',
        movingListToFavourite: 'Spostamento {{listName}} nelle liste preferite',
        nameIsEmpty: 'Il nome è vuoto'
    },
    
    en: {
        // Form placeholders
        name: 'Name',
        nameTask: 'Name of the task',
        description: 'Description',
        descriptionTask: 'Description of the task',
        
        // Date placeholders
        whenTaskNeedToStart: 'When the task need to start',
        whenTaskNeedToEnd: 'When the task need to end',
        whenYouPlanToStartTask: 'When you plan to start the task',
        whenYouPlanToEndTask: 'When you plan to end the task',
        
        // Actions and buttons
        close: 'Close',
        save: 'Save',
        ok: 'OK',
        saveData: 'Save data',
        
        // Modal titles and alerts
        error: 'ERROR',
        success: 'Success',
        info: 'INFO',
        deleted: 'DELETED',
        oooops: 'OOOOOPS',
        
        // Messages
        savingData: 'Saving data',
        nameIsEmpty: 'Name is empty',
        thereAreSomeProblems: 'There are some problem during the save of the data',
        taskDeletedCorrectly: 'Task {{taskName}} deleted correctly',
        areYouSure: 'Are you sure?',
        areYouSureDeleteTask: 'Are you sure that you want to delete the task {{taskName}}?',
        
        // Navigation and general
        home: 'Home',
        newTask: 'New task',
        yes: 'YES',
        no: 'NO',
        
        // Boards specific
        yourBoards: 'Your boards',
        preferredBoards: 'Preferred boards',
        otherBoards: 'Other boards',
        hereYouCanFindYourPreferredBoards: 'Here you can find your preferred boards',
        hereYouCanFindOtherBoards: 'Here you can find the other boards',
        addNewBoard: 'Add new board',
        openBoard: 'Open board',
        edit: 'Edit',
        delete: 'Delete',
        boardDeletedCorrectly: 'Board {{boardName}} deleted correctly',
        areYouSureDeleteBoard: 'Are you sure that you want to delete the board {{boardName}}?',
        dragToReorderLists: 'Drag to reorder lists',
        
        // Task Editor specific
        taskLinkedToList: 'This task is linked to the Activity List',
        fromTheBoard: 'from the board',
        progress: 'Progress',
        startDate: 'Start date',
        endDate: 'End date',
        plannedStartDate: 'Planned start date',
        plannedEndDate: 'Planned end date',
        executor: 'Executor',
        verifier: 'Verifier',
        validator: 'Validator',
        progressLimitError: 'Progress can\'t be more than 100. Automatically set to 100',
        taskNameEmptyError: 'The name of the task can\'t be empty',
        taskUpdatedSuccess: 'Task updated with success',
        nothingToSave: 'Nothing to save',
        theBoard: 'The board',
        activityList: 'Activity list',
        thisTask: 'This Task',
        
        // Activity List specific
        preferredLists: 'Preferred Lists',
        otherLists: 'Other Lists',
        hereYouCanFindYourPreferredLists: 'Here you can find your preferred lists',
        hereYouCanFindTheOtherLists: 'Here you can find the other lists',
        newActivityList: 'New activity list',
        newTask: 'New task',
        areYouSureDeleteList: 'Are you sure that you want to delete the board {{boardName}}?',
        listDeletedCorrectly: 'Board {{boardName}} deleted correctly',
        movingListToOther: 'Moving {{listName}} to the other lists',
        movingListToFavourite: 'Moving {{listName}} to the favourite lists',
        nameIsEmpty: 'Name is empty'
    }
}; 